import { atom } from "jotai";
import type { tOutputSettings } from "./types";
import {
  OUTPUT_DEFAULT_DATA_FILE_NAME,
  OUTPUT_DEFAULT_FRAMEWORK,
  OUTPUT_DEFAULT_IMAGE_QUALITY,
  OUTPUT_DEFAULT_PIXI_GEN_TS_CODE,
  OUTPUT_DEFAULT_PNG_COMPRESSION,
  OUTPUT_DEFAULT_TEXTURE_FILE_NAME,
  OUTPUT_DEFAULT_TEXTURE_FORMAT,
} from "#config";
import {
  activeProjectIdAtom,
  activeProjectOutputSettingsAtom,
  updateProjectAtom,
} from "@/projects/projects.atom";

const defaultSettings: tOutputSettings = {
  framework: OUTPUT_DEFAULT_FRAMEWORK,
  textureFormat: OUTPUT_DEFAULT_TEXTURE_FORMAT,
  dataFileName: OUTPUT_DEFAULT_DATA_FILE_NAME,
  textureFileName: OUTPUT_DEFAULT_TEXTURE_FILE_NAME,
  pngCompression: OUTPUT_DEFAULT_PNG_COMPRESSION,
  imageQuality: OUTPUT_DEFAULT_IMAGE_QUALITY,
  pixiGenTs: OUTPUT_DEFAULT_PIXI_GEN_TS_CODE,
};
export const outputSettingsAtom = atom<
  tOutputSettings,
  [Partial<tOutputSettings>],
  undefined
>(
  (get) => get(activeProjectOutputSettingsAtom) || defaultSettings,
  (get, set, value) => {
    const projectId = get(activeProjectIdAtom);
    if (!projectId) return;
    set(updateProjectAtom, projectId, {
      outputSettings: {
        ...get(outputSettingsAtom),
        ...value,
      },
    });
  },
);

// the only usage of this one is to force rerender the output settings form
export const outputSettingsFormVersionAtom = atom(0);
export const incOutputSettingsFormVersionAtom = atom(null, (get, set) => {
  set(outputSettingsFormVersionAtom, get(outputSettingsFormVersionAtom) + 1);
});
